
export const GET_ALL_BANNER_DATA = "GET_ALL_BANNER_DATA";
export const GET_BANNER_DATA = "GET_BANNER_DATA";
export const DELETE_BANNER = "DELETE_BANNER";
